import type { KycStatus } from "../../shared/types"

export const withSession = (sessionId: string): Record<string, string | number | boolean> =>
  sessionId ? { verification_session_id: sessionId } : {}

export const kycResultOf = (status: KycStatus): string => {
  if (status === "accepted") {
    return "approved"
  }
  if (status === "declined") {
    return "declined"
  }
  if (status === "timeout" || status === "cancelled") {
    return "expired"
  }

  return "in_review"
}
